export default "__VITE_ASSET__60d39c3e__"